import type { ProviderInfo } from '../lib/providers'
import { providerOptionLabel } from '../lib/providers'

// Provider selection for BYO keys — the single shared component for BOTH
// Settings and onboarding (parity invariant). Options come from
// lib/providers.ts (server-driven catalog): disabled entries render as
// "coming soon" and cannot be selected; the backend also rejects them on
// save/verify.

interface ProviderSelectProps {
  id: string
  value: string
  onChange: (provider: string) => void
  providers: ProviderInfo[]
  className?: string
}

export function ProviderSelect({ id, value, onChange, providers, className }: ProviderSelectProps) {
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    >
      {providers.map((p) => (
        <option key={p.id} value={p.id} disabled={!p.enabled}>
          {providerOptionLabel(p)}
        </option>
      ))}
    </select>
  )
}
